import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=cbed95a0&scoped=true&"
import script from "./Mobile.vue?vue&type=script&lang=ts&"
export * from "./Mobile.vue?vue&type=script&lang=ts&"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=cbed95a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbed95a0",
  null
  
)

export default component.exports